import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="header-main">
      <div className="header-container">
        <div className="header-logo">
          <h2 className="logo-text">Dr. Subhashini G</h2>
          <span className="logo-subtitle">For Bar Council 2026</span>
        </div>

        {/* Desktop Navigation */}
        <nav className="nav-desktop">
          <button onClick={() => scrollToSection('about')} className="nav-link">
            About
          </button>
          <button onClick={() => scrollToSection('vision')} className="nav-link">
            Vision
          </button>
          <button onClick={() => scrollToSection('commitments')} className="nav-link">
            Commitments
          </button>
          <button onClick={() => scrollToSection('achievements')} className="nav-link">
            Achievements
          </button>
          <button onClick={() => scrollToSection('contact')} className="nav-link">
            Contact
          </button>
        </nav>

        <a 
          className="btn-primary header-cta-desktop mobile-hidden text-capitalize"
          href="https://wa.me/919177864071" target="_blank" rel="noopener noreferrer"
        >
          WhatsApp Me
        </a>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <nav className="nav-mobile">
          <button onClick={() => scrollToSection('about')} className="nav-link-mobile">
            About
          </button>
          <button onClick={() => scrollToSection('vision')} className="nav-link-mobile">
            Vision
          </button>
          <button onClick={() => scrollToSection('commitments')} className="nav-link-mobile">
            Commitments
          </button>
          <button onClick={() => scrollToSection('achievements')} className="nav-link-mobile">
            Achievements
          </button>
          <button onClick={() => scrollToSection('contact')} className="nav-link-mobile">
            Contact
          </button>
          <a 
            className="btn-primary text-capitalize"
            // onClick={() => scrollToSection('contact')}
            href="https://wa.me/919177864071" target="_blank" rel="noopener noreferrer"
            style={{ width: '100%', marginTop: '12px' }}
          >
            WhatsApp Me
          </a>
        </nav>
      )}
    </header>
  );
};

export default Header;
